import React from "react";
import { motion } from "framer-motion";
import { FaLightbulb, FaUsers, FaGraduationCap, FaBook } from "react-icons/fa";

const AboutUs = () => {
  return (
    <div
      className="min-h-screen bg-cover bg-center flex items-center justify-center p-6"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1534777410513-385b6de78411?auto=format&fit=crop&w=1470&q=80')",
      }}
    >
      <div className="bg-white bg-opacity-90 backdrop-blur-md rounded-3xl shadow-2xl max-w-5xl w-full flex flex-col overflow-hidden p-8">
        <motion.h1
          className="text-4xl md:text-5xl font-bold text-center text-indigo-600 mb-6"
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          About Vicademics
        </motion.h1>

        <motion.p
          className="text-gray-700 text-lg text-center mb-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          Vicademics is an innovative online learning platform where instructors
          can create and share rich educational courses. Learners around the
          world can explore video lessons, detailed articles, and engaging
          quizzes — all in one place.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <motion.div
            className="bg-gradient-to-br from-indigo-500 to-blue-600 text-white rounded-xl p-6 flex flex-col items-center text-center"
            whileHover={{ scale: 1.05 }}
          >
            <FaLightbulb size={40} className="mb-4" />
            <h3 className="text-xl font-semibold mb-2">Our Vision</h3>
            <p>
              Empower individuals worldwide to learn, create, and grow with
              accessible, high-quality online education.
            </p>
          </motion.div>

          <motion.div
            className="bg-gradient-to-br from-pink-500 to-red-500 text-white rounded-xl p-6 flex flex-col items-center text-center"
            whileHover={{ scale: 1.05 }}
          >
            <FaUsers size={40} className="mb-4" />
            <h3 className="text-xl font-semibold mb-2">Our Community</h3>
            <p>
              A thriving community of passionate instructors and curious
              learners united by the joy of knowledge.
            </p>
          </motion.div>

          <motion.div
            className="bg-gradient-to-br from-green-500 to-emerald-500 text-white rounded-xl p-6 flex flex-col items-center text-center"
            whileHover={{ scale: 1.05 }}
          >
            <FaGraduationCap size={40} className="mb-4" />
            <h3 className="text-xl font-semibold mb-2">For Learners</h3>
            <p>
              Gain access to a wide range of expertly designed courses, valid
              for one year after purchase.
            </p>
          </motion.div>

          <motion.div
            className="bg-gradient-to-br from-yellow-500 to-orange-500 text-white rounded-xl p-6 flex flex-col items-center text-center"
            whileHover={{ scale: 1.05 }}
          >
            <FaBook size={40} className="mb-4" />
            <h3 className="text-xl font-semibold mb-2">For Instructors</h3>
            <p>
              Share your knowledge through videos, articles, and quizzes —
              inspiring learners everywhere.
            </p>
          </motion.div>
        </div>

        <motion.div
          className="mt-8 text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8 }}
        >
          <h2 className="text-2xl font-bold text-indigo-600 mb-2">
            Join Vicademics Today 🚀
          </h2>
          <p className="text-gray-700">
            Whether you’re here to teach or to learn, Vicademics empowers your
            journey every step of the way.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default AboutUs;
